export class Payload{
    access_token: string;
}